import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../auth';
import { useMediaQuery } from 'react-responsive';
import { HeaderWeb, SidebarComponent, TableSalesDark, TableSalesLight, TableSalesPageAdminDark, TableSalesPageAdminLight } from '../../components';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../api';


function Sales() {

    const { theme } = useContext(ThemeContext);
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [loading, setLoading] = useState(true);
    const [listSales, setListSales] = useState([]);

    const retrieveSales = () => {
        setLoading(true);
        axiosAuth.get(`/api/users`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.role.roleName === "Sales");

                setListSales(filterData);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveSales();
    }, [accessToken]);


    const [listLead, setListLead] = useState([]);

    const retrieveLead = () => {
        setLoading(true);
        axiosAuth.get(`/api/leads`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item.status == 100);

                setListLead(filterData);

                setLoading(false);
            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

                setLoading(false);
            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveLead();
    }, [accessToken]);


    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}
            >
                <div className={isMobile ? 'ms-1' : 'ms-3 me-1'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Sales
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <br />
                <br />
                {loading ? (
                    <div
                        className='d-flex justify-content-center align-items-center'
                        style={{ height: '200px' }}
                    >
                        <Spinner animation='border' style={{ color: theme === 'light' ? '#F3C623' : '#2f4b7c' }} />
                    </div>
                ) : userInfo.role.roleName === 'Admin' ? (
                    <div className={isMobile ? 'mx-1' : 'mx-3'}>
                        <TableSalesPageAdminDark
                            listLead={listLead}
                            accessToken={accessToken}
                        />
                    </div>
                ) : (
                    <div className={isMobile ? 'mx-1' : 'mx-3'} >
                        <TableSalesDark
                            listSales={listSales}
                            accessToken={accessToken}
                        />
                    </div>
                )}
                <br />
                <br />
            </div>
        </div>
    )
}

export default Sales
